import React, { useEffect } from "react";
import { Image, StyleSheet, View } from "react-native";
import LoadingDots from "react-native-loading-dots";
import { AutoSizeText, ResizeTextMode } from "react-native-auto-size-text";
import { StatusBar } from "expo-status-bar";
import { Colors } from "../styles";

export default function Loading({ message = "Carregando", setIsSplashFinish }) {

  useEffect(() => {
    const timer = setTimeout(() => {
      if (setIsSplashFinish) setIsSplashFinish(true);
    }, 5000); // 5000 milissegundos = 5 segundos

    return () => clearTimeout(timer); // Limpa o timer se o componente for desmontado antes do término do atraso
  }, [setIsSplashFinish]);

  return (
    <View style={styles.animationContainer}>
      <StatusBar translucent={true} backgroundColor={Colors.WHITE}/>
      {/* <LottieView
        autoPlay
        loop={!setIsSplashFinish}
        onAnimationFinish={() => {
          if (setIsSplashFinish) setIsSplashFinish(true);
        }}
        source={require("../../assets/trevo-lottie.json")}
        resizeMode={"cover"}
        style={{ height: 300 }}
        speed={0.5}
      /> */}
      <Image 
      source={require("../../assets/trevo-lottie.gif")}
      resizeMethod="scale"
      style={styles.logoGif}
      />
      <View style={styles.messageContainer}>
        <AutoSizeText
          numberOfLines={1}
          mode={ResizeTextMode.max_lines}
          fontSize={25}
          style={styles.messageText}
        >
          {message}
        </AutoSizeText>
        <View style={{ width: 200 }}>
          <LoadingDots
            size={10}
            bounceHeight={5}
            colors={["#c52128", "#d04d53", "#dc797e", "#e7a6a9"]}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  animationContainer: {
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    backgroundColor: "#eee",
  },
  messageContainer: {
    position: "absolute",
    bottom: 50,
    alignItems: "center",
  },
  messageText: {
    fontSize: 25,
    marginBottom: 20,
    marginHorizontal: 8,
  },
  logoGif:{
    width: 350,
    height: 350
  }
});
